import { ref } from 'vue';

export function useToast(timeout = 5000) {
  const showToast = ref(false);
  const toastTitle = ref('');
  const toastMessage = ref('');
  const toastType = ref('info');
  let toastTimeout = null;

  const displayToast = (title, message, type = 'info') => {
    toastTitle.value = title;
    toastMessage.value = message;
    toastType.value = type;
    showToast.value = true;

    if (toastTimeout) {
      clearTimeout(toastTimeout);
    }

    toastTimeout = setTimeout(() => {
      hideToast();
    }, timeout);
  };

  const hideToast = () => {
    showToast.value = false;
    if (toastTimeout) {
      clearTimeout(toastTimeout);
    }
  };

  return {
    showToast,
    toastTitle,
    toastMessage,
    toastType,
    displayToast,
    hideToast
  };
}